module.exports = __webpack_public_path__ + "img/farming_43.9e202bde.png";